import LdSlideOut from 'lion-vue-shared/components/LdSlideOut/LdSlideOutContainer';
import { HC_PROPS, initHCProps } from '../index';

export { initHCProps, HC_PROPS };
export default LdSlideOut;
